import React, { Component } from "react";

class FormError extends Component {
  render() {
    let messages = "";
    let colClass = "col-lg-8";
    if (this.props.fullColumn) {
      colClass = "col-lg-12";
    }

    if (this.props.errors.length > 0) {
      messages = (
        <div className="form-row justify-content-center mt-3">
          <div className={`${colClass} pt-3`}>
            <div className="alert alert-danger" role="alert">
              <ul className="pl-3">
                {this.props.errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    }

    return messages;
  }
}

export default FormError;
